import React from 'react'
import './Name.css'

const Name = () => {
  return (
    <div className='Name'>
      <h1 className='Name__header'>Dzmitry Dubovik</h1>      
      <h3 className='Name__job'>Frontend (React) and Backend Developer</h3>
      <div className='Name__qualities'>
        <p className='qualities_title' style={{textDecoration: 'underline'}}>Personal qualities:</p>
        <p className='qualities_text'>Inquisitive, hardworking, initiative, executive, communicative, without bad habits.</p>   
        <p>I am interested in solving complex problems and doing interesting projects.</p>
        <p>Marital status: single.</p>
      </div>
    </div>
  )
}

export default Name